import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/custom.css';

// Components
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import DriverDashboard from './components/dashboard/DriverDashboard';
import AccountSettings from './components/AccountSettings';
import PrivateRoute from './components/PrivateRoute';
import ChangeEmail from './components/ChangeEmail';
import VerifyEmail from './components/VerifyEmail';
import SetPassword from './components/SetPassword';
import RootRedirect from './components/RootRedirect';
import SignUp from './components/SignUp';
import NewBookingLink from './components/admin/NewBookingLink';
import Checkout from './components/checkout/Checkout';
import ThankYou from './components/ThankYou';
import Leaderboard from './components/Leaderboard';
import LatestResults from './components/LatestResults';
import BookingCreate from './components/booking/BookingCreate';
import DashboardNavbar from './components/shared/DashboardNavbar';
import SessionExpiredDialog from './components/SessionExpiredDialog';
import SimulatorAssignments from './components/SimulatorAssignments';

// Context
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <SessionExpiredDialog />
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify/:guid" element={<VerifyEmail />} />
            <Route path="/change-email/:changeId" element={<ChangeEmail />} />
            <Route path="/newpassword/:linkId" element={<SetPassword />} />
            <Route path="/admin/bookinglinks" element={<NewBookingLink />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/leaderboard/:id" element={<Leaderboard />} />
            <Route path="/:type/leaderboard/:id" element={<Leaderboard />} />
            <Route path="/latest/:id" element={<LatestResults />} />
            <Route element={<DashboardNavbar />}>
            <Route 
              path="/dashboard"
              element={
                <PrivateRoute>
                  <DriverDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard/settings"
              element={
                <PrivateRoute>
                  <AccountSettings />
                </PrivateRoute>
              }
            />
            <Route
              path="/booking"
              element={
                <PrivateRoute>
                  <BookingCreate />
                </PrivateRoute>
              }
            />
            </Route>
            <Route path="/simulator-assignments/:location" element={<SimulatorAssignments />} />
            <Route path="/" element={<RootRedirect />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
